import React, { useState } from 'react'
import { Box, Button } from '@mui/material'
import { EditProfileForm } from './EditProfileForm'
import { useLocation } from 'react-router-dom'

export const EditProfile = (props) => {
  const { pathname = '', search = '' } = useLocation()
  const [show, setShow] = useState(false)

  const handleShowForm = () => {
    setShow(!show)
  }

  const returnTo = () => {
    return '?' + new URLSearchParams({ return_to: `${pathname}${search}` }).toString()
  }

  const handleProfile = () => {
    window.location.href = `/profile${returnTo()}`
  }
  return (
    <Box>
      <Box display='flex' flexDirection='column'>
        <Box my={3}>
          <Button onClick={handleProfile} variant='contained'>
            Edit Profile
          </Button>
        </Box>
        <Box display={show ? 'none' : 'block'}>
          <Button variant='contained' color='primary' onClick={handleShowForm}>
            Settings
          </Button>
        </Box>
      </Box>
      <EditProfileForm show={show} handleShowForm={handleShowForm} />
    </Box>
  )
}
